"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToBase64 = void 0;
function hexToBase64(hexString) {
    let base64 = "";
    for (let i = 1; i < hexString.length + 1; i += 2) {
        base64 += String.fromCharCode(parseInt(hexString.substring(i - 1, i + 1), 16));
    }
    return btoa(base64);
}
exports.hexToBase64 = hexToBase64;
